import { usePresentationDelete } from '@/module/Author/Presentation';

import { DeleteButton } from '@/core/components';

import { Id, useDelete } from '@feature/utils';

interface PresentationDeleteButtonProps {
  presentationId: Id;
}

export function PresentationDeleteButton({ presentationId }: PresentationDeleteButtonProps) {
  const mutation = usePresentationDelete(presentationId);
  const deleteProps = useDelete({
    mutation,
    navigateTo: { to: '..' },
  });

  return (
    <DeleteButton
      size="xs"
      {...deleteProps}
    />
  );
}
